import { DataForm } from '@tencent/data-schema/lib/vue-ui/DataForm';
import Markdown from "../../../lib/builtin/components/Markdown";
import { INJECT_UICORE_BUS } from "../../../lib/utils/consts";
import { cloneDeep } from "lodash-es";
import FieldLabel from "../../../lib/comps/PropPanel/components/FieldLabel";
import { ParamContext } from "../../../lib/comps/PropPanel/PropPanel/ParamItem/ParamContext";
import { EventPanelModes } from "../../../lib/comps/PropPanel/PropPanel/ParamItem/ParamInputMode";
const __script_base__ = {
  name: 'StepEditPopover',
  components: {
    ParamContext,
    DataForm,
    Markdown
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    }
  },
  props: {
    atom: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      eventPanelModes: EventPanelModes,
      params: {
        ...cloneDeep(this.atom.defaultParams),
        ...this.step.params
      },
      backfill: {
        value: this.step.backfill || '',
        active: !!this.step.backfill
      }
    };
  },
  methods: {
    handleFormChangeEvent(val) {
      this.$emit('update:params', val);
    }
  },
  watch: {
    backfill: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.backfill.active) this.$emit('update:backfill', '');else this.$emit('update:backfill', this.backfill.value);
      }
    }
  },
  computed: {
    backfillActive() {
      return !!(this.backfill.active && this.backfill.value);
    },
    dataSchemaContextOptions() {
      const self = this;
      return {
        ...this.uc.getDataFormContextOptions({
          extraComponents: this.atom.paramsFormComponents
        }),
        evalExtraCtx: {
          get params() {
            return self.params || {};
          }
        },
        FieldLabel
      };
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-sfeParams"
  }, [_c("param-context", {
    staticClass: "uc-dataForm uc-dataForm-vertical",
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      schema: _vm.atom.paramsSchema,
      "context-options": _vm.dataSchemaContextOptions,
      "keep-ref": true,
      "input-modes": _vm.eventPanelModes,
      "reset-mode": "default"
    },
    on: {
      change: _vm.handleFormChangeEvent
    },
    model: {
      value: _vm.params,
      callback: function ($$v) {
        _vm.params = $$v;
      },
      expression: "params"
    }
  }), _vm._v(" "), _vm.atom.desc ? _c("section", {
    staticClass: "ucd-sfeParams-section"
  }, [_c("markdown", {
    attrs: {
      source: _vm.atom.desc,
      "open-in-new-window": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), false && _vm.atom.returnValue ? _c("section", {
    staticClass: "ucd-sfeParams-section"
  }, [_c("markdown", {
    attrs: {
      source: "此步骤会输出 " + _vm.atom.returnValue,
      "open-in-new-window": ""
    }
  }), _vm._v(" "), _c("p", {
    staticClass: "ucd-sfeParams-returnValue"
  }, [_c("label", [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: _vm.backfill.active,
      expression: "backfill.active",
      modifiers: {
        lazy: true
      }
    }],
    staticClass: "uc-checkbox",
    attrs: {
      type: "checkbox"
    },
    domProps: {
      checked: Array.isArray(_vm.backfill.active) ? _vm._i(_vm.backfill.active, null) > -1 : _vm.backfill.active
    },
    on: {
      change: function ($event) {
        var $$a = _vm.backfill.active,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.backfill, "active", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.backfill, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.backfill, "active", $$c);
        }
      }
    }
  }), _vm._v("\n        传递给后续步骤\n      ")]), _vm._v(" "), _vm.backfill.active ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.backfill.value,
      expression: "backfill.value"
    }],
    staticClass: "uc-inputbox",
    class: {
      hasError: !_vm.backfill.value
    },
    attrs: {
      placeholder: "请输入变量名"
    },
    domProps: {
      value: _vm.backfill.value
    },
    on: {
      input: function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.backfill, "value", $event.target.value);
      }
    }
  }) : _vm._e()]), _vm._v(" "), _vm.backfillActive ? _c("markdown", {
    attrs: {
      "open-in-new-window": "",
      source: "后续步骤中可通过 `{{ flowState." + _vm.backfill.value + " }}` 引用"
    }
  }) : _vm._e()], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "simpleFlow/SimpleFlowEditor/StepParamsEditor.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);